<template>
  <vs-input
    :label="label"
    v-mask="customMask"
    placeholder="+7 ___ __-__-__"
    type="tel"
    inputmode="tel"
    v-validate="`${required ? 'required|min:16' : 'min:16'}`"
    :name="errorsScope"
    v-bind="$attrs"
    :value="value"
    v-on="inputListeners"
    :danger="errors.has(errorsScope)"
    danger-text="Телефон должен состоять из 11 цифр"
  />
</template>

<script>
export default {
  name: 'InputPhone',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Телефон'
    },
    required: {
      type: Boolean,
      default: true
    },
    errorsScope: {
      type: String,
      default: 'phone'
    }
  },
  data() {
    return {
      customMask: {
        mask: '+7 F## ###-##-##',
        tokens: {
          'F': { pattern: /(?!8)\d/ },
          '#': { pattern: /\d/ }
        }
      }
    }
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners
      }
    }
  }
}
</script>
